<template>
  <div
    class="box self_c self_vipcard"
    v-bind:style="'height:' + boxWh + 'px;'"
  >
    <headNav color="#56AC9A" />
    <div class="self_b">
      <div
        class="self_content_ "
        style="margin-bottom: 15px;margin-top:46px;"
      >
        <img
          class="me_img"
          v-if="memberUrl"
          :src="memberUrl"
          :style="`height:${meHeight}px;`"
        />

        <div class="me_list-box">
          <div
            class="me_item"
            @click="goUpdatePhone()"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_mobile.png"
            />
            <div class="me_item-title">{{ window_c["Mobile number 2"] }}</div>
            <div class="me_item-content">{{ userInfo.phone }}</div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <div
            class="me_item"
            @click="updateSetting('name')"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_account_name.png"
            />
            <div class="me_item-title">{{ window_c["Account name 2"] }}</div>
            <div class="me_item-content">{{ userInfo.memberName }}</div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <div
            class="me_item"
            @click="updateSetting('email')"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_email.png"
            />
            <div class="me_item-title">{{ window_c["Email 2"] }}</div>
            <div class="me_item-content">{{ userInfo.email }}</div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <div
            class="me_item"
            @click="updateSetting('date')"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_birthday.png"
            />
            <div class="me_item-title">{{ window_c["Birthday"] }}</div>
            <div class="me_item-content">{{ userInfo.birthday }}</div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <div
            class="me_item "
            @click="updateSetting('sex')"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_sexial.png"
            />
            <div class="me_item-title">{{ window_c["Sexual"] }}</div>
            <div class="me_item-content">
              {{
                userInfo.sex == "1"
                  ? window_c["male"]
                  : userInfo.sex == "2"
                  ? window_c["female"]
                  : ""
              }}
            </div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <div class="self_max_line"></div>
          <!-- <div class="me_item" @click="showLang_()">
					<img class="me_item-icon" src="../../assets/icon/lang.png" />
					<div class="me_item-title">{{ window_c['update language'] }}</div>
					<div class="me_item-content">{{ foodStoryLanguage }}</div>
					<img class="me_item-right" src="../../assets/icon/icn-back-white.png" />
				</div> -->
          <div
            class="me_item"
            @click="updateSetting('lang')"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/lang.png"
            />
            <div class="me_item-title">{{ window_c["update language"] }}</div>
            <div class="me_item-content">{{ foodStoryLanguage }}</div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <div
            class="me_item"
            @click="goUpdatePassword()"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_password.png"
            />
            <div class="me_item-title">{{ window_c["Login password"] }}</div>
            <div class="me_item-content"></div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>

          <div
            v-show="1 == 2"
            class="me_item"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/inc_address.png"
            />
            <div class="me_item-title">{{ window_c["Address"] }}</div>
            <div class="me_item-content"></div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <!--  v-if="1==2"
        v-if="1==2" -->
          <div class="self_max_line"></div>
          <div
            class="me_item"
            @click="goReservation()"
          >
            <img
              class="me_item-icon"
              src="../../assets/icon/icn_booking.png"
            />
            <div class="me_item-title">{{ window_c["My reservation"] }}</div>
            <div class="me_item-content"></div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
          <!-- 推薦有禮 -->
          <div
            class="max_line"
            v-if="showRecommendation"
          ></div>
          <div
            class="me_item"
            v-if="showRecommendation"
            @click="goRecom()"
          >
            <van-icon
              class="me_item-icon"
              name="gift-card-o"
            />
            <div
              class="me_item-title"
              v-text="window_c['Invite to enjoy discount']"
            ></div>
            <div class="me_item-content"></div>
            <img
              class="me_item-right"
              src="../../assets/icon/icn-back-white.png"
            />
          </div>
        </div>
      </div>

      <div
        class="cell-button"
        style="margin-top: auto;margin-bottom: 15px;"
      >
        <van-button
          class="self_bg_color"
          @click="unLogin()"
          color="#5abba7"
          type="primary"
          size="large"
        >{{ window_c["Logout"] }}</van-button>
      </div>
    </div>
    <!-- 煩哦 vant 的 dialog 組件是不是有毒 ,怎麼寫都掉兩次確定方法,靠 , 哥哥自己寫-->
    <van-overlay
      :show="dialogData.show"
      @click="
        dialogData.show = false;
        dialogData.type = -1;
      "
    />
    <div
      v-show="dialogData.show"
      class="s-dialog_box"
    >
      <div
        class="s-dialog_title"
        :style="'font-size:16px;'"
        v-show="dialogData.type != 4"
      >
        {{ dialogData.title }}
      </div>
      <div class="s-dialog_content">
        <van-cell-group v-if="dialogData.type == 1 || dialogData.type == 3">
          <van-field
            v-model="dialogData.value"
            :placeholder="dialogData.placeholder"
          />
        </van-cell-group>
        <van-radio-group
          v-else-if="dialogData.type == 2"
          class="sex"
          v-model="dialogData.radio"
        >
          <van-radio
            name="1"
            checked-color="#07c160"
          >{{
            window_c["male"]
          }}</van-radio>
          <van-radio
            name="2"
            checked-color="#07c160"
          >{{
            window_c["female"]
          }}</van-radio>
        </van-radio-group>
        <van-radio-group
          v-else-if="dialogData.type == 5"
          v-model="lang_.select_"
        >
          <van-cell-group>
            <van-cell
              :title="lang_.actions[0].name"
              clickable
              @click="lang_.select_ = '0'"
            >
              <van-radio
                slot="right-icon"
                name="0"
              />
            </van-cell>
            <van-cell
              :title="lang_.actions[1].name"
              clickable
              @click="lang_.select_ = '1'"
            >
              <van-radio
                slot="right-icon"
                name="1"
              />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <van-datetime-picker
          @change="pickerChange"
          :visible-item-count="pickerDate.visibleItemCount"
          :title="dialogData.title"
          confirm-button-text=" "
          cancel-button-text=" "
          v-else-if="dialogData.type == 4"
          v-model="pickerDate.currentDate"
          type="date"
          :min-date="pickerDate.minDate"
          :max-date="pickerDate.maxDate"
        />
      </div>
      <div class="s-dialog_btn">
        <van-button
          class="self_bg_color"
          style="border-radius: 7px;"
          @click="closeDialog()"
          type="default"
          color="#56AC9A"
          size="large"
        >{{ window_c["confirm"] }}</van-button>
      </div>
    </div>

    <van-action-sheet
      v-model="lang_.show"
      :actions="lang_.actions"
      @select="onLangSelect"
    />

    <!-- <iframe :src="thUrl" style="display: none;"></ifram> -->
  </div>
</template>

<script>
import { updateMemberInfo } from "@/js/api";
import headNav from "@/components/headNav";
import util from "@/js/util.js";
import lang_ from "@/js/locales";
export default {
  data () {
    return {
      window_c: {
        Birthday: '生日',
        Sexual: '性別',
        'Login password': '登錄密碼',
        Address: '收貨地址',
        'Mobile number 2': '電話號碼',
        'Account name 2': '名稱',
        'Email 2': '電郵',
        male: '男',
        female: '女',
        secrecy: '保密',
        'Modify name': '修改名稱',
        'Modify email': '修改電郵',
        'Revision of birthday': '修改名稱',
        'Gender modification': '修改性別',
        confirm: '確認',
        cancel: '取消',
        'Warm reminder': '溫馨提示',
        'Confirm logout': '確認退出登錄',
        'Please enter a name': '請輸入名稱',
        'Please enter email': '請輸入電郵',
        Logout: '登出',
        'update language': '修改語言',
        Loading: '加載中...',
        'Update success': '更新成功',
        English: '英文',
        'Traditional Chinese': '中文繁體',
        'With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?': '如果更改您的生日，您将无法在365天内获得生日优惠。是否继续？',
        'My reservation': '我的訂座',
        "Invite to enjoy discount": "邀請有禮"
      },
      lang_: {
        show: false,
        actions: [
          {
            name: "English"
          },
          {
            name: "中文繁體"
          }
        ],
        select_: "0"
      },
      settingList: [],
      Wh: 0,
      size16: 0,
      boxWh: 0,
      dialogData: {
        show: false,
        title: "",
        placeholder: "",
        value: "",
        type: -1,
        radio: "0",
        birthday: "2018-01-15"
      },
      userInfo: [],
      requestParam: {
        memberName: "", //暱稱
        email: "", //郵箱
        birthday: "", //生日
        sex: 0, //性別 2:女 1：男 其他：保密
        disName: "",
        proName: "",
        memberId: 0, //用戶id 必傳
        check: 1 //默認為1
      },
      pickerDate: {
        minDate: new Date("1900/01/01"),
        maxDate: new Date(),
        currentDate: new Date(),
        visibleItemCount: 3,
        selectDate: ""
      },
      thUrl: '',
      foodStoryLanguage: '中文繁體',
      memberUrl: '',
      meHeight: 0,
      showRecommendation: false
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this);
    this.init_lang();
    this.initWindow();
  },
  mounted () {
    this.memberUrl = this.memberBackgroundUrl;
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c['Birthday'] = lang_.t('Birthday');
      window_c['Sexual'] = lang_.t('Sexual');
      window_c['Login password'] = lang_.t('Login password');
      window_c['Address'] = lang_.t('Address');
      window_c['Mobile number 2'] = lang_.t('Mobile number 2');
      window_c['Account name 2'] = lang_.t('Account name 2');
      window_c['Email 2'] = lang_.t('Email 2');
      window_c['male'] = lang_.t('male');
      window_c['female'] = lang_.t('female');
      window_c['secrecy'] = lang_.t('secrecy');
      window_c['Modify name'] = lang_.t('Modify name');
      window_c['Modify email'] = lang_.t('Modify email');
      window_c['Revision of birthday'] = lang_.t('Revision of birthday');
      window_c['Gender modification'] = lang_.t('Gender modification');
      window_c['confirm'] = lang_.t('confirm');
      window_c['cancel'] = lang_.t('cancel');
      window_c['Warm reminder'] = lang_.t('Warm reminder');
      window_c['Confirm logout'] = lang_.t('Confirm logout');
      window_c['Please enter a name'] = lang_.t('Please enter a name');
      window_c['Please enter email'] = lang_.t('Please enter email');
      window_c['Logout'] = lang_.t('Logout');
      window_c['Loading'] = lang_.t('Loading');
      window_c['Update success'] = lang_.t('Update success');
      window_c['update language'] = lang_.t('update language');
      window_c['English'] = lang_.t('English');
      window_c['Traditional Chinese'] = lang_.t('Traditional Chinese');
      window_c['With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?'] =
        lang_.t(
          'With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?'
        );
      window_c['My reservation'] = lang_.t('My reservation');
      window_c['Invite to enjoy discount'] = lang_.t('Invite to enjoy discount')
      this.lang_.actions[0].name = window_c['English'];
      this.lang_.actions[1].name = window_c['Traditional Chinese'];
      if (localStorage.foodStoryLanguage == 'en') {
        this.foodStoryLanguage = window_c['English'];
        this.lang_.select_ = '0';
      } else {
        this.foodStoryLanguage = window_c["Traditional Chinese"];
        this.lang_.select_ = "1";
      }
    },
    initWindow () {
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      this.Wh = h;
      this.boxWh = h - 50;
      this.meHeight = w / 1.833;
      let userInfoStr = util.userInfo.get(this);
      if (userInfoStr) {
        var userinfo = JSON.parse(userInfoStr);
        this.requestParam.memberId = userinfo.memberId;
        this.userInfo = userinfo;
        this.pickerDate.selectDate = userinfo.birthday;
        if (userinfo.birthday) {
          this.pickerDate.currentDate = new Date(
            userinfo.birthday.replace(/-/g, "/")
          );
        }
      }
      let codeT = setInterval(() => {
        let code = localStorage.getItem('invitation_code');
        if (code == 0 || code == 1) {
          this.showRecommendation = code == 0 ? false : true;
          clearInterval(codeT);
        }
      }, 30)
      this.size16 = util.GETVW_VHBYPX('vw', 16);
    },
    showLang_ () {
      this.lang_.show = true;
      setTimeout(function () {
        document
          .getElementsByClassName("van-action-sheet")[0]
          .style.setProperty("z-index", "9999", "important");
      }, 300);
    },
    goUpdatePhone () {
      this.$router.push({
        name: "update_phone",
        params: this.$route.params.arg
      });
    },
    goUpdatePassword () {
      let brandId = util.getBrandId(this);
      let phone = this.userInfo.phone + "_" + "2";
      this.$router.push({
        name: "update_password",
        params: {
          arg: util.setQueryParams([brandId, phone])
        }
      });
    },
    goReservation () {
      this.$router.push({
        name: "reservation_list",
        arg: util.setQueryParams([util.getBrandId(this)])
      });
    },
    onLangSelect (item) {
      this.lang_.show = false;
      console.log(item.name);
      if (item.name == this.window_c["English"]) {
        localStorage.foodStoryLanguage = "en";
      } else {
        localStorage.foodStoryLanguage = "hk";
      }
      location.reload();
    },
    updateSetting (e) {
      var self = this;
      this.dialogData.show = true;
      if (e == "name") {
        this.dialogData.type = 1;
        this.dialogData.title = this.window_c["Modify name"];
        this.dialogData.placeholder = this.window_c["Please enter a name"];
        this.dialogData.value = this.userInfo.memberName;
      } else if (e == "email") {
        this.dialogData.type = 3;
        this.dialogData.title = this.window_c["Modify email"];
        this.dialogData.placeholder = this.window_c["Please enter email"];
        this.dialogData.value = this.userInfo.email;
      } else if (e == "sex") {
        this.dialogData.type = 2;
        this.dialogData.radio = this.userInfo.sex + "";
        this.dialogData.title = this.window_c["Gender modification"];
      } else if (e == "date") {
        this.dialogData.type = 4;
        this.pickerDate.currentDate = "";
        this.pickerDate.currentDate = new Date(
          self.userInfo.birthday.replace(/-/g, "/")
        );
        this.dialogData.title = this.window_c["Revision of birthday"];
      } else if (e == "lang") {
        this.dialogData.type = 5;
        this.dialogData.title = "";
      }
    },
    closeDialog () {
      this.dialogData.show = false;
      var type = this.dialogData.type;
      if (type == -1) return;
      switch (type) {
        case 1:
          console.log(this.dialogData.value);
          this.requestParam.memberName = this.dialogData.value;
          break;
        case 2:
          console.log(this.dialogData.radio);
          this.requestParam.sex = this.dialogData.radio;
          break;
        case 3:
          if (!util.ISEMAIL(this.dialogData.value)) {
            this.$toast(lang_.t("Incorrect mailbox format"));
            return;
          }
          this.requestParam.email = this.dialogData.value;
          break;
        case 4:
          this.requestParam.birthday = this.pickerDate.selectDate;
          break;
        default:
          break;
      }
      if (type == 5) {
        if (this.lang_.select_ == "0") {
          localStorage.foodStoryLanguage = "en";
        } else {
          localStorage.foodStoryLanguage = "hk";
        }
        location.reload();
        return;
      }
      this.updateMemberInfo_(type);
    },
    pickerChange (e) {
      var val = e.getValues();
      this.pickerDate.selectDate = val[0] + "-" + val[1] + "-" + val[2];
      console.log(this.pickerDate.selectDate);
    },
    unLogin () {
      var self = this;
      this.$dialog
        .confirm({
          title: self.window_c["Warm reminder"],
          message: self.window_c["Confirm logout"],
          confirmButtonText: self.window_c["cancel"],
          cancelButtonText: self.window_c["confirm"],
          cancelButtonColor: self.themeColor,
          confirmButtonColor: "#222"
        })
        .then(() => { })
        .catch(() => {
          util.userInfo.clear(this);
          self.$router.replace({
            name: "login",
            params: {
              arg: util.setQueryParams(util.getBrandId(this, 1))
            }
          });
        });
    },
    updateMemberInfo_ (type, req) {
      var self = this;
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: self.window_c["Loading"]
      });

      var data = {};
      if (!util.ISNULL(req)) {
        data.data = req;
      } else data.data = JSON.stringify(self.requestParam);
      data.memberId = self.requestParam.memberId;

      updateMemberInfo(data).then(res => {
        self.$toast.clear();
        if (res.code == 1) {
          self.$toast(self.window_c["Update success"]);
          self.userInfo;
          switch (type) {
            case 1:
              self.userInfo.memberName = self.requestParam.memberName;
              self.requestParam.memberName = "";
              break;
            case 2:
              self.userInfo.sex = self.requestParam.sex;
              self.requestParam.sex = "";
              break;
            case 3:
              self.userInfo.email = self.requestParam.email;
              self.requestParam.email = "";
              break;
            case 4:
              self.userInfo.birthday = self.requestParam.birthday;
              self.requestParam.birthday = "";
              break;
            default:
              break;
          }
          util.userInfo.set(this, self.userInfo);
        } else {
          if (type == 4) {
            self.checkBirthday(res.errorMsg);
          }
        }
      });
    },
    checkBirthday (msg) {
      console.log(msg);
      var self = this;
      self.$dialog
        .confirm({
          title: self.window_c["Warm reminder"],
          message:
            self.window_c[
            "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?"
            ],
          confirmButtonText: self.window_c["cancel"],
          cancelButtonText: self.window_c["confirm"],
          cancelButtonColor: self.themeColor,
          confirmButtonColor: "#222"
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
          var req = JSON.parse(JSON.stringify(self.requestParam));
          delete req.check;
          self.updateMemberInfo_(4, JSON.stringify(req));
        });
    },
    goRecom () {
      this.$router.push({
        name: 'recommendation'
      })
    }
  },
  watch: {
    memberBackgroundUrl () {
      this.memberUrl = this.memberBackgroundUrl;
    }
  },
  components: {
    headNav
  }
};
</script>
<style lang="less" scoped>
.self_b {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.box {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.self_content_ {
  background-color: #fff;
}

.me_img {
  width: 100%;
  height: 100px;
}

.me_list-box {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.me_item {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding: 10px;
  /*3vw;*/
}

.me_item:after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  transform: scaleY(0.5);
  background-color: rgb(245, 245, 245);
}

.self_max_line {
  height: 25px;
  background-color: rgb(245, 245, 245);
}

#app .me_item-icon {
  width: 26px;
  /*7vw;*/
  height: 26px;
  /*7vw;*/
  font-size: 26px;
}

.me_item-title {
  font-size: 16px;
  /*3.5vw;*/
  margin-left: 10px;
}

.me_item-content {
  margin-left: auto;
  font-size: 16px;
  /*3.5vw;*/
  margin-right: 30px;
}

.me_item-right {
  width: 22px;
  /*6vw;*/
  height: 22px;
  /*6vw;*/
}

.cell-button {
  padding: 0 50px;
}

.cell-button button {
  border-radius: 15px;
}

.s-dialog_content .sex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  padding: 10px;
}

.s-dialog_box {
  position: fixed;
  top: 45%;
  left: 50%;
  width: 85%;
  overflow: hidden;
  /* font-size: 16px; */
  background-color: #fff;
  border-radius: 4px;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  z-index: 2;
}

.s-dialog_title {
  padding: 24px;
  line-height: 24px;
  text-align: center;
}

.s-dialog_content {
  width: 100%;
  min-height: 50px;
  padding: 10px;
}

.s-dialog_btn {
  padding: 20px 10px;
}

.pc_content .self_b {
  padding-top: 46px;
}
</style>
<style>
.pbody .van-dialog {
  max-width: 340px;
}
</style>



// WEBPACK FOOTER //
// src/view/my/index.vue